export class ProjectMailingDocumentRecipientDTO {
    mailingDocumentRecipientId: number;
    projectId: number;
    recipientName: string;    
    setsRequired: number;
    setsSent: number;
    updatedByUser: string;
    loggedUser: string;
}
